import Vue from 'vue'

import Vuetify from 'vuetify/lib'
// locale
import en from '@/locale/en'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: {en},
    current: 'en',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          base: '#000000',
          darken1: '#000000',
          lighten1: '#000000',
          lighten2: '#000000',
        },
        secondary: '#cb972c',
        accent: '#2f4858',
        error: '#e35044',
        info: '#3896d9',
        success: '#82c55e',
        warning: '#f2b443',
        background: '#f7f8f9',
      },
      dark: {
        primary: {
          base: '#000000',
          darken1: '#000000',
          lighten1: '#000000',
          lighten2: '#000000',
        },
        secondary: '#cb972c',
        accent: '#2f4858',
        error: '#e35044',
        info: '#3896d9',
        success: '#82c55e',
        warning: '#f2b443',
      },
    },
  },
  defaults: {
    VBtn: {
      rounded: false,
    },
    VCard: {
      rounded: false,
    },
    VDialog: {
      rounded: false,
    },
    VTextField: {
      rounded: false,
    },
    VChip: {
      rounded: false,
    },
    VAvatar: {
      rounded: false,
    },
  },
})
